
// Define all media-related types in a central location
import { Json } from "@/integrations/supabase/types";

export type MediaType = "all" | "infographic" | "photo" | "video";

export interface MediaItemData {
  id: string;
  title: {
    en: string;
    ar: string;
  };
  type: "infographic" | "photo" | "video";
  image: string;
  videoUrl?: string;
  sdgId: number;
}

// Sample/fallback media gallery data with reliable image URLs
export const sampleMediaGalleryData: MediaItemData[] = [
  {
    id: "m1",
    title: {
      en: "SDG 4: Education in Palestine",
      ar: "الهدف 4: التعليم في فلسطين"
    },
    type: "infographic",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=1722&auto=format&fit=crop",
    sdgId: 4
  },
  {
    id: "m2",
    title: {
      en: "Water Conservation Techniques",
      ar: "تقنيات الحفاظ على المياه"
    },
    type: "infographic",
    image: "https://images.unsplash.com/photo-1581244277943-fe4d9aa3faeb?q=80&w=1974&auto=format&fit=crop",
    sdgId: 6
  },
  {
    id: "m3",
    title: {
      en: "Sustainable Farming Workshop",
      ar: "ورشة عمل الزراعة المستدامة"
    },
    type: "photo",
    image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?q=80&w=1470&auto=format&fit=crop",
    sdgId: 2
  },
  {
    id: "m4",
    title: {
      en: "Women Artisans Cooperative",
      ar: "تعاونية الحرفيات"
    },
    type: "photo",
    image: "https://images.unsplash.com/photo-1594708767771-a7502209ff51?q=80&w=1470&auto=format&fit=crop",
    sdgId: 5
  },
  {
    id: "m5",
    title: {
      en: "Youth Climate Action",
      ar: "العمل المناخي للشباب"
    },
    type: "photo",
    image: "https://images.unsplash.com/photo-1573032688505-4fa068a5bd02?q=80&w=1470&auto=format&fit=crop",
    sdgId: 13
  },
  {
    id: "m6",
    title: {
      en: "Clean Energy Solutions",
      ar: "حلول الطاقة النظيفة"
    },
    type: "video",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?q=80&w=1472&auto=format&fit=crop",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    sdgId: 7
  },
  {
    id: "m7",
    title: {
      en: "Urban Gardens in Refugee Camps",
      ar: "الحدائق الحضرية في مخيمات اللاجئين"
    },
    type: "video",
    image: "https://images.unsplash.com/photo-1555089548-8a9ed8a9a9d1?q=80&w=1470&auto=format&fit=crop",
    videoUrl: "https://www.youtube.com/embed/QH2-TGUlwu4",
    sdgId: 11
  },
  {
    id: "m8",
    title: {
      en: "Traditional Knowledge in Agriculture",
      ar: "المعرفة التقليدية في الزراعة"
    },
    type: "infographic",
    image: "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?q=80&w=1374&auto=format&fit=crop",
    sdgId: 15
  },
];
